// ============================================================================
// CrewAhead Maritime Platform - Tailwind Class Merge Utility
// ============================================================================

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines multiple class strings and objects into a single className string,
 * resolving Tailwind CSS conflicts using tailwind-merge.
 *
 * @param inputs - Class values to merge (strings, objects, arrays, conditionals)
 * @returns Merged className string with Tailwind conflicts resolved
 *
 * @example
 * ```tsx
 * <div className={cn('px-4 py-2', isActive && 'bg-blue-500', className)} />
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
